import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { PageHeader, PageBody } from "@/components/common/PageHeader";
import EmptyState from "@/components/common/EmptyState";
import { PackageSearch } from "lucide-react";

export default function StockTransfers() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/stock-transfers").then(({ data }) => setItems(data)); }, []);
    return (
        <>
            <PageHeader kicker="INVENTORY" title="Stock Transfers" subtitle="Movements between warehouses." />
            <PageBody>
                <div className="bg-card border border-border rounded-md overflow-hidden">
                    {items.length === 0 ? <EmptyState icon={PackageSearch} title="No stock transfers yet" /> :
                        <table className="fin-table">
                            <thead><tr><th>Number</th><th>Date</th><th>Item</th><th className="num">Qty</th></tr></thead>
                            <tbody>{items.map((t) => (<tr key={t.id}><td className="font-mono text-[12px]">{t.number}</td><td className="text-[12px] text-muted-foreground">{fmtDate(t.date)}</td><td>{t.item_id}</td><td className="num">{t.quantity}</td></tr>))}</tbody>
                        </table>}
                </div>
            </PageBody>
        </>
    );
}
